import * as config from "./config"

import "firebase/compat/auth"
import firebase from "firebase/compat/app"

export const firebaseApp = firebase.initializeApp(config.firebase)
